import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_NEW,
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('authToken');
  if (token) cfg.headers['Authorization'] = `Bearer ${token}`;
  return cfg;
});


api.interceptors.response.use(res => res, err => {
  if (err.response && err.response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  }
  return Promise.reject(err);
});
export default api;